import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { questionsQueryKeys } from './questionsQueryKeys';

const getQuestionsStates = async () => {
  return await request.get(
    '/Question/states',
    {},
    'При загрузке статусов вопросов произошла ошибка',
    []
  );
};

const useQuestionsStates = (options) =>
  useQuery(questionsQueryKeys.states(), getQuestionsStates, options);

export default useQuestionsStates;
